<div class="main">
    <div class="container-fluid">
        <div class="agenda-items-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="agenda-items-title-container mb-3 mb-md-0">
                <h3>Agenda Items</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="agenda-items-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>Agenda Items</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3">
                <button class="create-agenda-btn text-white" (click)="createAgenda()">
                    Create Agenda
                </button>
                <button class="upload-btn rounded-pill text-white" (click)="uploadAgendaItems()" aria-label="Upload agenda items">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M10 2.5V13.75M10 2.5L6.25 6.25M10 2.5L13.75 6.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.5 13.75V16.25C2.5 17.0784 3.17157 17.75 4 17.75H16C16.8284 17.75 17.5 17.0784 17.5 16.25V13.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <app-data-table
            [data]="agendaItems"
            [columns]="tableColumns"
            [paginator]="true"
            [rows]="10"
            (onActionClick)="onTableActionClick($event)"
            (onLinkClick)="onTableLinkClick($event)">
        </app-data-table>
    </div>
</div>

